import { GetterTree } from 'vuex'
import { State } from './state'
import {ProductAggregatedStatUruchomieniaSum} from "@/store/modules/statsUruchomienia/types";


export function aggregatedStatsUruchomieniaSumUpdating (state: State): boolean {
    return state.aggregatedStatsUruchomieniaSumUpdating;
}

export function aggregatedStatsUruchomieniaSum (state: State): Array<ProductAggregatedStatUruchomieniaSum> {
    return state.aggregatedStatsUruchomieniaSum;
}

export function aggregatedStatsUruchomieniaLoading (state: State): boolean {
    return state.aggregatedStatsUruchomieniaLoading;
}

export function aggregatedStatsUruchomienia (state: State): Array<object> {
    return state.aggregatedStatsUruchomienia;
}

export function aggregatedStatsUruchomieniaTotal (state: State): number {
    return state.aggregatedStatsUruchomieniaTotal;
}

export function detailedStatsUruchomieniaLoading (state: State): boolean {
    return state.detailedStatsUruchomieniaLoading;
}

export function detailedStatsUruchomienia (state: State): Array<object> {
    return state.detailedStatsUruchomienia;
}

export default <GetterTree<State, any>> {
    aggregatedStatsUruchomieniaSumUpdating,
    aggregatedStatsUruchomieniaSum,
    aggregatedStatsUruchomieniaLoading,
    aggregatedStatsUruchomienia,
    aggregatedStatsUruchomieniaTotal,
    detailedStatsUruchomieniaLoading,
    detailedStatsUruchomienia
}
